import { add, type Duration, format } from '@sequencehq/utils/dates'
import { BillingSchedule } from 'modules/Customer/hooks/useFetchBillingSchedules'
import { phaseDateFormat, scheduleLabels } from 'modules/Cube/cube.constants'

/** The values shown on the review step before executing the renewal. */
export type RenewalReview = {
  customerId: string
  originalStartDate: string
  originalEndDate: string
  renewalDate: string
  duration: string
  newEndDate: string
}

/**
 * Review values: the renewal starts on the renewal start date and runs for the
 * contract duration, so the schedule's new end date is that far after the
 * renewal starts. An open-ended quote (no total duration) leaves it open-ended.
 */
export const buildRenewalReview = ({
  schedule,
  customerId,
  renewalStartDate,
  totalPricingDuration,
  duration
}: {
  schedule: BillingSchedule
  customerId: string
  renewalStartDate: Date
  totalPricingDuration: Duration | undefined
  duration: string
}): RenewalReview => ({
  customerId,
  originalStartDate: schedule.startDate,
  originalEndDate: schedule.endDate,
  renewalDate: renewalStartDate.toISOString(),
  duration,
  newEndDate: !totalPricingDuration
    ? scheduleLabels.openEnded
    : format(add(renewalStartDate, totalPricingDuration), phaseDateFormat)
})
